import $ from 'jquery';
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import templatePayouts from './routes/payouts';
import templateAddCampaign from './routes/template-add-campaign';
import campaignTemplateDefault from './routes/template-add-campaign';
import templateInfluencerMyProfile from './routes/user-settings';
import templateInfluencerSettings from './routes/user-settings';
import templateCompanyMyProfile from './routes/user-settings';
import templateCompanySettings from './routes/user-settings';
import templateDarkCelebrityCalculator from './routes/template-dark-celebrity-calculator';
import templateInfluencersFilter from './routes/template-influencers-filter';
import singleCampaign from './routes/single-campaign';
import wpAdmin from './routes/wp-admin';
import './styles/style.less';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	home,
	templatePayouts,
	templateAddCampaign,
	campaignTemplateDefault,
	templateInfluencerMyProfile,
	templateInfluencerSettings,
	templateCompanyMyProfile,
	templateCompanySettings,
	singleCampaign,
	templateDarkCelebrityCalculator,
	templateInfluencersFilter,
	wpAdmin
});

/** Load Events */
$(document).ready(() => routes.loadEvents());
